export default __webpack_public_path__ + "static/media/Hellspawned Wristguard.a0b60af0.jpg";